import { SIZES } from "@frontend/styles/constants";

export const TIME_PICKER_TAG_NAME = "time-picker" as const;

export const TIME_PICKER_LAYOUTS = ["default", "text"] as const;

export const DEFAULT_MINUTE_STEP = 5;

export const ARROW_SIZES: Record<(typeof SIZES)[number], number> = {
  sm: 6,
  md: 8,
  lg: 10,
};
